<template>
    <div class="header">
        <div class="system-title">
            <img src="/logo.png" alt="Logo" class="header-logo">
            <span class="title-grad">青少年人工智能高水平创新人才培养 课程平台</span>
        </div>
        <div class="menu-list">
            <div @click="toPage('index')" :class="$route.path == '/'?'menu_item':''">主页</div>
            <div @click="toPage('myTask')" :class="$route.path == '/myTask'?'menu_item':''">我的课程</div>
            <div @click="toPage('teacher')" :class="$route.path == '/teacher'?'menu_item':''">教师</div>
            <div @click="toPage('notice')" :class="$route.path == '/notice'?'menu_item':''">公告</div>
            <div @click="toPage('message')" :class="$route.path == '/message'?'menu_item':''">留言</div>
        </div>
        <div class="center">
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    <img class="header-avatar" :src="avatarSrc(userInfo.avatar)" @error="onAvatarError">
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a"><div class="drop-item"><i class="el-icon-user"></i>个人中心</div></el-dropdown-item>
                    <el-dropdown-item command="b"><div class="drop-item"><i class="el-icon-s-management"></i>我的课程</div></el-dropdown-item>
                    <el-dropdown-item command="i"><div class="drop-item"><i class="el-icon-s-management"></i>收藏课程</div></el-dropdown-item>
                    <el-dropdown-item command="d"><div class="drop-item"><i class="el-icon-reading"></i>我的作业</div></el-dropdown-item>
                    <el-dropdown-item command="g"><div class="drop-item"><i class="el-icon-circle-close"></i>错题集</div></el-dropdown-item>
                    <el-dropdown-item command="h" divided><div class="drop-item"><i class="el-icon-back"></i>退出登陆</div></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <span class="username">{{userInfo.userName}}</span>
        </div>
    </div>
</template>

<script>
  import {mixin} from "../../minix";
  export default {
    mixins: [mixin],
    data() {
      return{
        userInfo: {},
      }
    },
    methods: {
        handleCommand(command) {
		  if (command == 'a') {
              this.$router.push("/center")
		  } else if(command == 'b') {
			  this.$router.push("/myTask")
		  } else if(command == 'd') {
			  this.$router.push("/myAssign")
		  } else if(command == 'g') {
              this.$router.push("/myWrongAssign")
		  } else if(command == 'i') {
              this.$router.push("/myFavor")
		  } else if(command == 'h') {
              this.$store.dispatch('logout').then(() => {
                window.localStorage.removeItem("user_info")
                window.localStorage.removeItem("user_token")
                this.$message({
                    message: '退出成功',
                    type: 'success'
                });
                setTimeout(function(){
                    window.location.reload()
                },1000)
              })
		  }
	    },
        toPage(name) {
          if (name == 'index') {
              this.$router.push("/")
          } else if (name == "myTask") {
              this.$router.push("/myTask")
          } else if (name == "teacher") {
              this.$router.push("/teacher")
          } else if (name == "message") {
              this.$router.push("/message")
          } else if (name == "notice") {
              this.$router.push("/notice")
          }
      },
    },
    created() {
     
    },
    mounted() {
      this.userInfo = JSON.parse(window.localStorage.getItem("user_info"))
    }
 }
</script>

<style scoped>
    @import url("../../assets/css/index/header.css");
    .title-grad {
        background: var(--grad-primary);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
    .header-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        border: 2px solid #FFFFFF;
        box-shadow: 0 0 0 2px #C7CDFF, 0 4px 10px rgba(91, 108, 255, 0.25);
        cursor: pointer;
        object-fit: cover;
    }
</style>